import { provideTransloco, TranslocoModule } from '@jsverse/transloco'
import { NgModule } from '@angular/core'
import { TranslocoHttpLoader } from './transloco-loader'
import { environment } from '../environments/environment'

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: [
          'sv-SE',
          'en-GB',
          'es-ES',
          'nb-NO',
          'da-DK',
          'de-DE',
          'fr-FR',
          'fi-FI',
        ],
        defaultLang: 'sv-SE',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
